import { Component } from '@angular/core';

/** Entry point propio de Áridos Mixer. */
@Component({
  selector: 'app-aridos-mixer-dashboard-entry',
  template: '<app-aridos-dashboard></app-aridos-dashboard>',
  standalone: false,
})
export class AridosMixerDashboardEntryComponent {}
